/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Events_NameInputs */



/**
* | output |
* | --- |
* | "Audio Events" |
*
* @param {Audio_Events_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_events_name = /** @type {((inputs?: Audio_Events_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Events_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Événements audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audioereignisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Аудиособытия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eventos de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオイベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो इवेंट्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Eventos de áudio")
	return /** @type {LocalizedString} */ ("Audio Events")
});